
//Page specific onboarding. Django views add key to template as necessary and track if viewed before.
function CheckOnboarding(){
    if ($("#onboarding_key").length > 0){
        var key = $("#onboarding_key").val();
        var show = $("#show_onboard").val() == "true";
        if(show) {
            LaunchOnboard(key);
        }
    }
}

function LaunchOnboard(key){
    var key = key || $("#onboarding_key").val();
    if(key.length > 0){
        httpGet(mantl.prefix_path('/onboarding/' + key)).then(
            function(value) {
                var $modal = buildModal(value,{
                    classes: 'modal modal--flat modal--onboarding animated bounceTiny',
                    header: ''
                });
                $('body').append($modal);
                $modal.on("modal:close",function(){
                    $modal.off("modal:close").remove();
                    $(".onboarding_trigger").addClass("animated puffIn");
                })
                $modal.openModal();
                $('#flowOnboard').flow({
                    animateHeight: true
                });
            }
        );
    }
}
